import {ActionButton} from "@fluentui/react";
import * as React from "react";

function GroupMail(props) {
    let emails = props.people.reduce((prev, curr,) => {
        const joined = curr.email.split(',').filter((item) => {
            return (item !== 'NULL' && item !== '');
        });
        return [...prev, ...joined];
    }, []);
    emails = emails.filter((value, index, self) => self.indexOf(value) === index).join(';');

    return (<a href={'mailto:?bcc=' + emails}><ActionButton iconProps={{iconName: 'PublicEmail'}}> Mail Grupowy</ActionButton></a>);
}

export default GroupMail;